import { useState, useEffect } from "react";
import moment from "moment";

function Thinking() {
  const [thinking, setThinking] = useState(
    moment().diff(moment().startOf("day"), "seconds")
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setThinking(moment().diff(moment().startOf("day"), "seconds"));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      id="thinking"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>Queria te dizer que, só hoje, pensei em você pelo menos</h1>
        <h2 id="counter" className="mb-0">
          {thinking.toLocaleString("pt-BR")}
        </h2>
        <h1>vezes...</h1>
      </div>
    </div>
  );
}

export default Thinking;
